/*
 * Copyright (c) 2021. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';
import { BasicFauxMenuViewModel, FauxMenuShape, FauxMenuSize } from 'src/types/view-models/faux-menu.view.model';
import BaseFauxMenu from './BaseFauxMenu';

export default class FauxMenu extends Component<BasicFauxMenuViewModel> {
    public override render(): ReactComponentElement<any> {
        return (
            <BaseFauxMenu
                shape={FauxMenuShape.DEFAULT}
                size={FauxMenuSize.DEFAULT}
                disabled={this.props.disabled || false}
                onClick={this.props.onClick}
                fullWidth={this.props.fullWidth}
                className={this.props.className}
                id={this.props.id}
            >
                {this.props.children}
            </BaseFauxMenu>
        );
    }
}
